import { UPDATE_CONSTANT } from './actionTypes';

export const updateConstant = (key, value, subkey) => (dispatch) => {
    dispatch({ type: UPDATE_CONSTANT, payload: { key, value, subkey } });
};
